/* eslint-disable no-underscore-dangle */

const AlarmsIOPoint = {
  service: (window as any)._env_.REACT_APP_ALARMS_IOPOINT_SERVICE || 'VOLMET',
  station: (window as any)._env_.REACT_APP_ALARMS_IOPOINT_STATION || 'VOLMET',
  group: (window as any)._env_.REACT_APP_ALARMS_IOPOINT_GROUP || 'VOLMET',
  variable: (window as any)._env_.REACT_APP_ALARMS_IOPOINT_VARIABLE || 'Volmet_LEST',
};

export default AlarmsIOPoint;
